export default class Storefront {
    storefront = ''
    domain = ''
    route = {}

    constructor(storefront) {
        if (storefront) {
            this.storefront = storefront.storefront
            this.domain = storefront.domain
            this.route = {...storefront.route}
        }
    }

    get currency() {
        return this.route.hasOwnProperty('currency')
            ? this.route.currency
            : ''
    }
}